import { some, startsWith, reduce, isString } from 'lodash';
import { guid } from '../../utils/guid';
export const appendFallbackUrlProtocol = url => {
  const hasProtocol = some(['http://', 'https://'], protocol => startsWith(url, protocol));
  return hasProtocol ? url : `https://${url}`;
};
const trimStrings = rawCard => {
  return reduce(rawCard, (result, value, key) => {
    if (isString(value)) {
      result[key] = value.trim();
      return result;
    }
    result[key] = value;
    return result;
  }, {});
};
export const parseJSON = rawCard => {
  rawCard = trimStrings(rawCard);
  if (rawCard.url) {
    rawCard.url = appendFallbackUrlProtocol(rawCard.url);
  }
  return {
    ...rawCard,
    clientId: rawCard.clientId || guid(),
    updatedTimestamp: rawCard.updatedTimestamp || Date.now()
  };
};
//# sourceMappingURL=parse-json.js.map